import { useDataIsSubmitting, useDataValue } from 'Simple/Data.js'

export function useDisabled(props) {
  let editor = useDataValue({
    context: 'editor',
    viewPath: props.viewPath,
  })
  let contract = useDataValue({
    context: 'payor',
    path: 'contract',
    viewPath: props.viewPath,
  })
  let isSubmitting = useDataIsSubmitting({
    context: 'payor',
    viewPath: props.viewPath,
  })

  return (
    !editor.disabled || editor.saving || contract.signed_date || isSubmitting
  )
}
